import type { IProgramCard } from './ProgramCard'

import { styled } from '@linaria/react'
import { TextBoxSC } from 'atoms/TextBox'
import { Wrapper } from 'blocks/TextBlock'
import { COLOR, FIXED_INDENTS, MEDIA } from 'vars/index'

export const ProgramCardSC = styled.div<
  Pick<
    IProgramCard,
    | 'width'
    | 'height'
    | 'disabled'
    | 'background'
    | 'backgroundHovered'
    | 'colorDisabled'
    | 'selected'
    | 'isLive'
    | 'clickableCard'
    | 'locked'
    | 'corners'
  > & { renderTitle: boolean; isThreeDots?: boolean }
>`
  display: flex;
  flex-direction: column;
  background: ${({ background }) => `var(${background})`};
  width: ${({ width, locked }) =>
    width && !locked
      ? `${width}px`
      : locked
        ? 'calc(100vw - (var(--adaptiveWidthCard) + var(--scrollbar-width))'
        : '100%'};
  min-width: ${({ width, locked }) =>
    width && !locked
      ? `${width}px`
      : locked
        ? 'calc(100vw - (var(--adaptiveWidthCard) + var(--scrollbar-width))'
        : '100%'};
  height: ${({ height }) => `${height}px`};
  justify-content: center;
  align-items: flex-start;

  border-radius: ${({ corners }) => `var(${corners})`};

  ${MEDIA.NO_TOUCH} {
    &:hover {
      background: ${({ backgroundHovered, disabled, background }) =>
        !disabled && backgroundHovered
          ? `var(${backgroundHovered})`
          : `var(${background})`};
      cursor: ${({ title, clickableCard, disabled, renderTitle }) =>
        title && clickableCard && !disabled && renderTitle
          ? 'pointer'
          : 'default'};
    }
  }

  ${Wrapper} {
    & > :nth-child(1) {
      width: 100%;
    }
  }

  ${TextBoxSC} {
    padding-left: var(${FIXED_INDENTS.INDENT_60});
    padding-right: var(${FIXED_INDENTS.INDENT_60});
    position: relative;

    text-overflow: ${({ isThreeDots }) =>
      isThreeDots ? 'initial' : 'ellipsis'};

    text-align: ${({ isThreeDots }) => (isThreeDots ? 'center' : 'left')};

    &:first-child {
      color: ${({ disabled, colorDisabled }) =>
        disabled ? `var(${colorDisabled})` : `var(${COLOR.TEXT_ICON_PRIMARY})`};

      &::after {
        content: '';
        width: 8px;
        height: 8px;
        background: var(${COLOR.ADDITIONAL_RED_2});
        border-radius: 50%;
        position: absolute;
        top: 7px;
        left: 8px;
        display: ${({ selected, isLive }) =>
          selected && isLive ? 'block' : 'none'};
      }
    }

    &:last-child {
      color: ${({ disabled, colorDisabled }) =>
        disabled
          ? `var(${colorDisabled})`
          : `var(${COLOR.TEXT_ICON_SECONDARY})`};
    }
  }
`
